// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.74 7.07006C10.74 5.8219 11.7518 4.81006 13 4.81006C14.2482 4.81006 15.26 5.8219 15.26 7.07006V10.5195H16.9138C17.4021 10.5195 17.8817 10.6492 18.3035 10.8954L21.9282 13.0111C23.0547 13.6687 23.5662 15.0257 23.1539 16.2632L21.3715 21.6138C20.9964 22.7397 19.9428 23.4992 18.7561 23.4992H11.6706C10.8144 23.4992 10.0068 23.1014 9.48499 22.4227L5.18666 16.8314L6.13621 15.4062C6.55747 14.7739 7.31812 14.4577 8.06347 14.6049L10.74 15.1337V7.07006Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 0H11V5H9V3.41421L5.41421 7H7V9H2V4H4V5.58579L7.58579 2H6V0Z"}}]};

const GestureExpansionFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-expansion-filled',
    ref,
    icon: element,
  },
));

GestureExpansionFilledIcon.displayName = 'GestureExpansionFilledIcon';

export default GestureExpansionFilledIcon;
